export default class TrainerAppointment {
    constructor() {
        this.instructor = {
            id: null,
            name: null,
            licenses: null,
        };
        this.offering = {
            id: null,
            key: null,
            title: null,
            isEditable: false,
            bookingMode: null,
            sport: {
                name: null,
            },
            category: {
                name: null,
            },
        };
        this.appointment = {
            start: null,
            end: null,
            canceled: false,
            originalInstructors: null,
        };
    }

    static fromData(data) {
        if (!data) {
            return;
        }

        const trainerAppointment = new TrainerAppointment();

        trainerAppointment.instructor = {
            id: data.instructor.id,
            name: data.instructor.name,
            licenses: data.instructor.licenses,
        };

        trainerAppointment.offering = {
            id: data.offering.id,
            key: data.offering.key,
            title: data.offering.title,
            isEditable: data.offering.isEditable ?? false,
            bookingMode: data.offering.bookingMode,
            sport: {
                name: data.offering.sport?.name ?? null,
            },
            category: {
                name: data.offering.category?.name ?? null,
            },
        };

        trainerAppointment.appointment = {
            start: data.appointment.start,
            end: data.appointment.end,
            canceled: data.appointment.canceled ?? false,
            originalInstructors: data.appointment.originalInstructors ?? null,
        };

        return trainerAppointment;
    }
}
